import React, { useState } from 'react';
import styles from './index.module.less';
import ImageConfirmation from '@/components/Content-Monitoring/Cpns/ImageSearchLoading/ImageConfirmation';
import LoadingProgress from './LoadingProgress';
import { useTranslation } from 'react-i18next';
import SendEmailModal from './SendEmailModal';

interface Props {
  stepDuration?: number;
  searchMode: 'low' | 'high';
  imageSearchUrl: string;
  taskId: number;
  isNeedPay?: boolean;
}

const Index: React.FC<Props> = ({ stepDuration, searchMode, imageSearchUrl, taskId, isNeedPay }) => {
  const { t } = useTranslation();
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [currentStep, setCurrentStep] = useState<number>(0);

  // 搜索文案
  const searchingText = searchMode === 'low' ? t('Searching...') : t('Unlocking Deep Search...');

  // 进度步骤
  const steps =
    searchMode === 'low'
      ? [
        { text: t('Analyzing image details'), duration: stepDuration || 15000 },
        { text: t('Matching against public image databases'), duration: stepDuration || 15000 },
        { text: t('Performing data analysis'), duration: stepDuration || 15000 },
        { text: t('Generating results'), duration: stepDuration || 15000 },
      ]
      : [
        { text: t('Collecting additional data'), duration: stepDuration || 15000 },
        { text: t('Scanning premium repositories'), duration: stepDuration || 15000 },
        { text: t('Enhancing analysis for complete results'), duration: stepDuration || 15000 },
        { text: t('Matching against exclusive databases'), duration: stepDuration || 15000 },
        { text: t('Generating final report'), duration: stepDuration || 15000 },
      ];

  const handleLoadingComplete = () => {
    setIsLoading(false);
  };

  return (
    <div className={styles.container}>
      <div className={styles.contentContainer}>
        {/* 左侧图片区域 */}
        <div className={styles.leftImageContainer}>
          <ImageConfirmation
            imageUrl={imageSearchUrl}
            isLoading={isLoading}
            currentStep={currentStep}
            searchMode={searchMode}
          />
        </div>

        {/* 右侧进度条区域 */}
        <div className={styles.rightProgressContainer}>
          <LoadingProgress
            onComplete={handleLoadingComplete}
            currentStep={currentStep}
            setCurrentStep={setCurrentStep}
            searchingText={searchingText}
            steps={steps}
          />
        </div>
      </div>

      {/* 底部是否发送邮件组件（need_pay 状态不显示） */}
      {!isNeedPay && <SendEmailModal taskId={taskId} />}
    </div>
  );
};

export default Index;
